var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLegalMattersSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 0C5.67173 0 5 0.671169 5 1.49976V2H1.5C0.671573 2 0 2.67157 0 3.5V11.5C0 12.3284 0.671573 13 1.5 13H14.5C15.3284 13 16 12.3284 16 11.5V3.5C16 2.67157 15.3284 2 14.5 2H11V1.49976C11 0.671169 10.3283 0 9.5 0H6.5ZM6.5 1H9.5C9.7763 1 10 1.22463 10 1.50061V2H6V1.49976C6 1.22377 6.2237 1 6.5 1ZM8.38649 7.91441L15 6.15081V11.5C15 11.7761 14.7761 12 14.5 12H1.5C1.22386 12 1 11.7761 1 11.5V6.15081L7.61351 7.91441C7.86674 7.98194 8.13326 7.98194 8.38649 7.91441ZM1.5 3H14.5C14.7761 3 15 3.22386 15 3.5V5.11586L8.12883 6.94817C8.04442 6.97068 7.95558 6.97068 7.87117 6.94817L1 5.11586V3.5C1 3.22386 1.22386 3 1.5 3Z",
    fill: "#5C5E69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegalMattersSvg);
export default __webpack_public_path__ + "static/media/legal-matters-svg.9a61420bcbdccc254be8df684c924b03.svg";
export { ForwardRef as ReactComponent };